import { environment } from '../../../../environments/environment';
import { GeneralResponse } from './../../models/general-response/general-response';
import { HttpService } from './../../http/http.service';
import { IChangePassword } from '../../models/change-password/change-password';
import { Injectable } from '@angular/core';
import { IValidataUser } from '../../models/user/user';
import { JwtHelperService } from '@auth0/angular-jwt';
import { LocalStorageService } from './../local-storage/local-storage.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private _storage: LocalStorageService,
    private jwtHelper: JwtHelperService,
    private httpService: HttpService) { }

  /**
   * Decodifico el token y retorno la informacion del usuario loggeado
   */
  getJWTValue(): any {
    const token = this._storage.getItemString(environment.LOCAL_STORAGE.LOGIN_USER_TOKEN);
    if (token) {
      return this.jwtHelper.decodeToken(token);
    } else {
      return null;
    }
  }

  /**
   * Funcion para cerrar la sesion
   * @param token Token de autenticacion
   */
  logout(token: string): Observable<GeneralResponse<any>> {
    const params = {
      idToken: token
    };

    return this.httpService.delete<GeneralResponse<any>>(
      environment.SEGURIDAD.API_LOGOUT_URL,
      '/logout/out',
      params
    ).pipe(
      map((response) => {
        return response;
      })
    );
  }

  /**
   * Funcion para cambiar la contrasenia
   * @param dataPassword interfaz con los datos para el cambio de contrasena
   */
  changePassword(dataPassword: IChangePassword) {
    return this.httpService.put(
      environment.SEGURIDAD.API_LOGOUT_URL,
      '/changePassword',
      dataPassword
    );
  }

  /**
   * Funcionar para validar el usuario
   * @param user interfaz con los datos del usuario a validar
   */
  validateUser(user: IValidataUser,afiliationOneToOne:boolean): Observable<GeneralResponse<any>> {
    let parameters:any = {
      idTypePerson: user.idTypePerson,
      idPerson: user.idPerson,
      idTypeEmployer: user.idTypeEmployer,
      idEmployer: user.idEmployer
    };
    if(afiliationOneToOne){
      parameters.afiliation = "1";
    }
    const params = parameters;

    return this.httpService.get<GeneralResponse<any>>(
      environment.AFILIACION.VALIDADOR_PERSONAS_API,
      '/validate',
      params
    ).pipe(
      map((response) => {
        return response;
      })
    );
  }

  refreshToken(token: string) : Observable<string> {
    const ciamUrl = environment.CIAM_URL_AUTHENTICATION_CIAM.replace("signin", "renovar");
    const body = {jwt: token};
    const customOptions = {responseType: 'text'}

    return this.httpService.post(
      ciamUrl,
      '',
      body,
      {},
      {},
      customOptions
    ).pipe(
      map((token: string) => {
        if (token) {
          localStorage.setItem(environment.CIAM_VAR_USERDATA, token);
        }
        return token;
      })
    );
  }

  verifyTokenCIAM(jwt: string): Observable<boolean> {
    const API_URL = environment.CIAM_URL_AUTHENTICATION_CIAM.replace("signin", "verify");

    const body = {
      jwt: jwt
    };

    return this.httpService.post<GeneralResponse<any>>(
      API_URL,
      '', 
      body,
      {},
      {},
      {observe: 'response'}
    ).pipe(
      map(response => {
        // Si el código de respuesta es 204, el token es válido
        return Number(response.status) === 204;
      })
    );
  }
}
